import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './BackButton.css';
import PropTypes from 'prop-types';

/**
 * Reusable Back Button Component
 * Matches the application's clean, dark slate button design.
 * 
 * @param {string} to - Optional specific path to navigate to. If omitted, navigates back (-1).
 * @param {string} text - Optional text to display next to the arrow. Defaults to 'Back'.
 * @param {function} onClick - Optional custom click handler to override default navigation.
 * @param {string} className - Optional extra CSS classes.
 */
const BackButton = ({ to, text = 'Back', onClick, className = '' }) => {
    const navigate = useNavigate();

    const handleBack = (e) => {
        if (onClick) {
            onClick(e);
            return;
        }
        if (to) {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <button
            className={`btn-back-shared ${className}`}
            onClick={handleBack}
            type="button"
        >
            <FontAwesomeIcon icon={faArrowLeft} className="back-btn-icon" /> {text}
        </button>
    );
};

BackButton.propTypes = {
    to: PropTypes.string,
    text: PropTypes.node,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

export default BackButton;
